export default __webpack_public_path__ + "static/media/css3.4af40b35.png";